import Header from "../../../../src/components/header";
import * as React from 'react';
export default {
  Header,
  React
};